"use client";

import { createContext, useContext } from "react";

type SsoConnectionContextValue = { hasSsoConnection: boolean; isPasswordManagedExternally: boolean };

const SsoConnectionContext = createContext<SsoConnectionContextValue>({
	hasSsoConnection: false,
	isPasswordManagedExternally: false,
});

export const SsoConnectionProvider = ({
	hasSsoConnection,
	isPasswordManagedExternally,
	children,
}: {
	hasSsoConnection: boolean;
	isPasswordManagedExternally: boolean;
	children: React.ReactNode;
}) => {
	return (
		<SsoConnectionContext.Provider value={{ hasSsoConnection, isPasswordManagedExternally }}>
			{children}
		</SsoConnectionContext.Provider>
	);
};

export const useHasSsoConnection = () => {
	const context = useContext(SsoConnectionContext);
	if (context === undefined) {
		throw new Error("useHasSsoConnection must be used within a SsoConnectionProvider");
	}
	return context;
};
